<div [style.background-color]="color()" class="file-item">
  <spb-document-name
    [name]="document().name"
    [url]="document().viewUrl!"
  ></spb-document-name>
  @if (removable()) {

    <button mat-icon-button aria-label="Ta bort dokumentet"
            (click)="remove.emit(document().id)"
    >
      <mat-icon
        class="remove">close
      </mat-icon>
    </button>

  }
</div>
